import React, { useState, useEffect } from "react";
import UsedCarLoan from "../../SubComponents/UsedCarLoan/Index";
import AllignedServices from "../../SubComponents/MaxPro/index";
import UserDetails from "../../SubComponents/Dashboard/UserDetails";
import CTabCard from "../../common/CTabCard";
import { View } from "react-native";
import TripInsurance from "../../SubComponents/TripInsurance";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import Dispute from "../Dispute";
import TripCreateRaiseDispute from "../../SubComponents/TripInsurance/TripCreateRaiseDispute";
import Header from "../../common/Header";
import Sidebar from "../../common/Sidebar";
import MobileHeader from "../../common/MobileHeader";
import TabHeader from "../../common/TabHeader";
import { Outlet, useLocation } from "react-router-dom";
import RootNavigation from "../../utilities/RootNavigation";


export default function OtherServices(props) {
  const {state} = useLocation()
  let pathName  = "insurance"
  const url = window.location.pathname?.toLowerCase()
  if(url == "/otherservices/usedcarloan"){
    pathName  = "loan"
  }else if(url == "/otherservices/maxpro"){
    pathName  = "alignedServices"
  }
  const styles = useStyles();
  const [activeScreen, setActiveScreen] = useState(pathName);
  const [selectedItem, setSelectedItem] = useState("OtherServices");
  const [selectedScreen, setSelectedScreen] = useState("");
  const [data, setData] = useState({});
  const [isFromDashboard, setIsFromDashboard] = useState(false);
  const [isShowSidebar, setIsShowSidebar] = useState(false);


  useEffect(() => {
      if (props?.route?.params?.screen) {
        setSelectedItem(props?.route?.params?.screen)
        setData(props?.route?.params?.disputeItem)
        global.navFromVD = false

      } else {
        setSelectedItem("")
        setActiveScreen(pathName)
        setSelectedScreen("home")

      }
  }, []);
  
  useEffect(() => {
    setSelectedItem(props?.route?.params?.screen)
    setData(props?.route?.params?.disputeItem)
    setSelectedScreen(props?.route?.params?.activeScreen)
  }, [props?.route?.params?.screen]);

  useEffect(() => {
    if (activeScreen == "insurance" || activeScreen == "loan") {
      global.navFromVD = false
      global.navFromDB = false
      global.navFromOS = true
    }
  }, [activeScreen]);


  function renderSwitch() {
    switch (activeScreen) {
      case "insurance":
        return <TripInsurance  selectedItem={selectedScreen} setActiveScreen={setActiveScreen}
          info={{
            backNavigation: 'DisputeHome',
          }} />
      case 'loan':
        return <UsedCarLoan setActiveScreen={setActiveScreen} />;
      case 'insuranceNotavailable':
        return <Dispute />;
      case 'alignedServices':
        return <AllignedServices setIsFromDashboard={isFromDashboard} />;

      default:
        return <UsedCarLoan setActiveScreen={setActiveScreen} />
    }
  }
  return (
    <View>
      <View>
        <Header />
        <MobileHeader isShowSidebar={setIsShowSidebar} />
        <TabHeader />
        <View style={styles.mainContainer}>
          <View style={styles.contentWidget}>
            {!isShowSidebar && <Sidebar />}
            <View style={styles.contentWrapper}  >
              <>
                {

                  (selectedItem == "CreateRiaseDispute")
                    ? <TripCreateRaiseDispute data={data}  />
                    : <>
                      <View style={styles.userWrapper}>
                        <UserDetails  />
                      </View>
                      <View style={styles.tabWrapper}>
                        <CTabCard
                          type="insurance"
                          isSelected={
                            activeScreen == "insurance" ||
                            activeScreen == "insuranceNotavailable"
                          }
                          onPress={() =>{
                            global.showTripInsurance  ?(
                              setActiveScreen("insurance"),
                              RootNavigation.navigate("OtherServices")
                            ) : (
                              setActiveScreen("insuranceNotavailable"),
                              RootNavigation.navigate("OtherServices/insurance")
                            )
                             
                          }}
                        />
                        <CTabCard
                          type="loan"
                          isSelected={activeScreen == "loan"}
                          onPress={() => {
                            setActiveScreen("loan")
                            RootNavigation.navigate("OtherServices/UsedCarLoan")
                          }}
                        />

                        <CTabCard
                          type="alignedServices"
                          isSelected={activeScreen == "alignedServices"}
                          onPress={() => {
                            setActiveScreen("alignedServices")
                            RootNavigation.navigate("OtherServices/maxpro")
                          }}
                          setIsFromDashboard={isFromDashboard}
        
                        />
                      </View>

                      <Outlet  context={{state}} />
                    </>
                }
              </>
            </View>
          </View>
        </View>
      </View>
    </View>
  )


}
const useStyles = CreateResponsiveStyle(
  {
    mainContainer: {
      width: "100%",
      height: '100vh',
      flexDirection: 'row',
      justifyContent: 'center',
      paddingTop: 40,
      backgroundColor: '#f2f4f5',
      backgroundImage:
        "linear-gradient(to top, #f2f4f5, #f2f4f5 50%, #eee 50%, #333 50%);",
    },
    contentWidget: {
      maxWidth: 1200,
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'center',
      paddingLeft: 80
    },
    contentWrapper: {
      width: '100%',
      marginLeft: 20
    },
    tabWrapper: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: 20,
      marginLeft: 20,
    },
    userWrapper: {
      marginLeft: 20,
    }
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {
      mainContainer: {
        justifyContent: 'flex-start',

      },
      contentWidget: {
        maxWidth: 999,
        justifyContent: 'flex-start',
        paddingLeft: 10,
        marginLeft: 0
      },
      contentWrapper: {
        width: '75%'
      }
    },
    [DEVICE_SIZES.SM]: {
      contentWidget: {
        paddingLeft: 0
      }
    },
    [DEVICE_SIZES.XS]: {
      tabWrapper: {
        flexDirection: 'column'
      },
      mainContainer: {
        paddingTop: 20,
        paddingLeft: 0,

      },
      contentWidget: {
        paddingLeft: 0,
        width: '90%',
        marginLeft: -10
      },
      userWrapper: {
        marginLeft: 13,
        width:'94%'
      }
    },
  }
);
  